import { Component, inject } from '@angular/core';
import { ActivatedRoute, Router, RouterLink, RouterLinkActive } from '@angular/router';
import { NgIcon } from '@ng-icons/core';
import { Select, Tab, TabGroup } from 'excellence-ui';
import { TranslocoPipe } from '@jsverse/transloco';
import { HasRoleDirective } from '../../../../shared/directives/has-role';

@Component({
  selector: 'app-energy-interface-details-nav',
  imports: [
    RouterLink,
    RouterLinkActive,
    TabGroup,
    Tab,
    NgIcon,
    Select,
    TranslocoPipe,
    HasRoleDirective,
  ],
  templateUrl: './energy-interface-details-nav.html',
})
export class EnergyInterfaceDetailsNav {
  private activatedRoute = inject(ActivatedRoute);
  private router = inject(Router);

  protected onSelectChange(url: string | string[] | null): void {
    this.router.navigate([url], {
      relativeTo: this.activatedRoute,
    });
  }
}
